import { useApi } from '@hooks/use-api-requests.hook'
import { useMobileUtils } from '../mobile-upload.utils'
import { useParams } from 'react-router-dom'
import { useEffect } from 'react'
import { useMobileContext } from '@hooks/use-mobile-context'

export function useValidateSession() {
	const { moveTo } = useMobileUtils()
	const { token } = useParams<'token'>()
	const { state } = useMobileContext()

	const [validSession, validateSession, isFetchingSession] = useApi<boolean>({
		request: 'DbOperations/validateMobileSession',
		method: 'POST',
		body: {
			idSessioneMobile: token || '',
			idRichiesta: state.idRichiesta,
		},
		sleeper: true,
		silent: true,
		shouldCache: false,
	})

	useEffect(() => {
		if (validSession !== undefined && validSession !== null) {
			if (!validSession) {
				moveTo('SESSION_EXPIRED')
			}
		}
	}, [validSession])

	return {
		validateSession,
		isFetchingSession,
		validSession: validSession ?? false,
	}
}
